import React, { useEffect, useState } from "react";
import { Row, Col , Button } from "react-bootstrap";
import Spinner from "../skills-experience/shared/spinner";
import payslipsLogo from "../../assets/EmployeePortal LP Payslips.svg";
import taxStatementsLogo from "../../assets/EmployeePortal LP Tax.svg";
import stayBenefitLogo from "../../assets/Stay Benefit.png";
import householdItemsLogo from "../../assets/Household Items.png";
// Reuse stay benefit logo for Household Items until a dedicated asset is provided.

// Added showStayBenefit prop so the Stay Benefit tile only displays when allowed by menu/visibility rules.
const PayrollLanding = ({ userName, showPayroll, showStayBenefit, showHouseholdItems, setLocation, setMenuOptions }) => {
    const [loading, setLoading ] = useState(true);    
    useEffect(() => {
        setMenuOptions("PayrollLanding");
        setLoading(false);
    }, []);

    const handleTileClick = (link) => {
        setLocation(link.url);
    }
        
    const getTiles = () => {
        const options = new Array();

        if(showPayroll) {
            options.push({
                url: "/Payslips",
                image: payslipsLogo,
                title: "Payslips",
                description: "View and Print your Payslips.",
            });

            options.push({
                url: "/TaxStatements", // Corrected casing to match route
                image: taxStatementsLogo,
                title: "Tax Statements",
                description: "View and Print your Tax Statements.",
            });

            if (showStayBenefit) {
                options.push({
                    url: "/StayBenefit",
                    image: stayBenefitLogo,
                    title: "Stay Benefit Form",
                    description: "Open and complete the Stay Benefit Form.",
                });
            }
            if (showHouseholdItems) {
                options.push({
                    url: "/HouseholdItems",
                    image: householdItemsLogo,
                    title: "Household Items Form",
                    description: "Open and complete the Household Items Form.",
                });
            }
        }

        return options;
    }

    const TileMode = () => (
        <>
         <Row className="mb-4">
                <Col className="text-center">
                    <h1>
                        Hello
                        {userName ? " " + userName : ""}!
                    </h1>
                </Col>
        </Row>
        <Row className="d-flex justify-content-center">
                {getTiles().map((link, i) => (
                    <Col className="col-12 col-md-3 mx-4 text-center">
                        <img
                            onClick={() => handleTileClick(link)}
                            style={{
                                cursor: 'pointer',
                                // Shrink Stay Benefit image slightly compared to others
                                height: '45%'
                            }}
                            src={link.image}
                            alt={link.title}
                            title={link.description}
                            className={ 'mb-3 link-icon' }
                        />
                        <br/>
                        <b className="mb-5">{link.title}</b>
                    </Col>
                ))}
            </Row>
        </>
    );

    return (
        <div className="skills-landing">
            {
                loading ?
                <>
                <Spinner show={loading}/>
                </>
                :
                <TileMode/>
            }
        </div>
    );
};

export default PayrollLanding;